import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../keycloack/auth.service';
import { ROLES } from '../utils/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private static readonly LOGIN_KEY = 'auth_login_ts';
  private static readonly MAX_AGE_MS = 30_000; // 30 secondi

  constructor(
    private keycloak: KeycloakService,
    private router: Router,
    private authService: AuthService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    const isLoggedIn = await this.keycloak.isLoggedIn();

    if (!isLoggedIn) {
      const savedTs = sessionStorage.getItem(AuthGuard.LOGIN_KEY);
      if (savedTs) {
        const elapsed = Date.now() - Number(savedTs);
        if (elapsed < AuthGuard.MAX_AGE_MS) {
          sessionStorage.removeItem(AuthGuard.LOGIN_KEY);
          return this.router.createUrlTree(['/errore']);
        }
      }
      sessionStorage.setItem(AuthGuard.LOGIN_KEY, String(Date.now()));
      return this.keycloak
        .login({
          redirectUri: window.location.origin + state.url,
        })
        .then(() => false);
    }

    sessionStorage.removeItem(AuthGuard.LOGIN_KEY);

    if (this.authService.hasRole(ROLES.superadmin) && !state.url.startsWith('/superadmin')) {
      return this.router.createUrlTree(['/superadmin/tenants']);
    }

    return true;
  }
}
